module.exports = __webpack_public_path__ + "fonts/steelfish outline.e7294714.woff";